module.exports = __webpack_public_path__ + "img/xinnaoxueuguan.7568b533.png";